import { formatDate } from "../utiles/Date";
import { http } from "./api";
import qs from "qs";

export const registerBusiness = async (business) => {
    try {
        // Si es FormData, configurar headers apropiadamente
        const config =
            business instanceof FormData
                ? { headers: { "Content-Type": "multipart/form-data" } }
                : {};

        const response = await http.post("v1/businesses/", business, config);

        // Verificación básica de la respuesta
        if (!response || typeof response.requestCode !== "number") {
            throw new Error("Respuesta del servidor inválida");
        }

        // Manejo de códigos de estado
        switch (response.requestCode) {
            case 201:
                return {
                    success: true,
                    requestCode: 201,
                    message: "Negocio creado exitosamente",
                    // data: response.data,
                };

            case 400:
                return {
                    success: false,
                    requestCode: 400,
                    message:
                        response.message || "Error en los datos proporcionados",
                    // data: response.data,
                };

            case 409:
                return {
                    success: false,
                    requestCode: 409,
                    message:
                        response.message ||
                        response.error ||
                        "El nombre del negocio ya está en uso",
                    // data: response.data,
                };

            default:
                return {
                    success: false,
                    requestCode: response.requestCode,
                    message:
                        response.message ||
                        "Error desconocido al registrar el negocio",
                    // data: response.data,
                };
        }
    } catch (error) {
        console.error("Error in business service:", error);

        // Manejo detallado de errores
        const errorMessage =
            error.response?.data?.message ||
            error.message ||
            "Error al conectar con el servidor";

        const errorCode = error.response?.status || 500;
        return {
            success: false,
            requestCode: errorCode,
            message: errorMessage,
        };
    }
};

export const getBusinessById = async (id) => {
    try {
        const response = await http.get(`v1/businesses/${id}`);

        return response.data;
    } catch (error) {
        console.error("Error in getBusinessById service:", error);
        return {
            success: false,
            message: "Error en la conexión con el servidor",
        };
    }
};

export const getBusiness = async (payload = {}) => {
    try {
        const params = {
            page: 1,
            limit: 10,
            offset: 0,
        };

        // Solo agregamos filters si hay algo en el payload
        // const filters = {};

        if (payload?.searchResult) {
            params.search = payload.searchResult;
        }

        if (payload?.statusResult) {
            params.status = payload.statusResult;
        }

        // if (payload?.dateFrom || payload?.dateTo) {
        //     params.date = {};

        //     if (payload.dateFrom) {
        //         filters.date.from = payload.dateFrom;
        //     }

        //     if (payload.dateTo) {
        //         filters.date.to = payload.dateTo;
        //     }
        // }

        // if (Object.keys(filters).length > 0) {
        //     params.filters = filters;
        // }

        const query = qs.stringify(params, {
            encode: true,
        });

        const path = `/v1/businesses?${query}`;
        const response = await http.get(path);

        if (response.requestCode === 400 || response.requestCode === 404) {
            return {
                success: true,
                message: "No hay negocios registrados",
                data: { meta: [], data: [] },
            };
        }

        const { meta, data: businesses } = response.data;

        const safeData = Array.isArray(businesses) ? businesses : [];

        const formattedBusinesses = safeData.map(
            ({
                id,
                businessName,
                createdAt,
                customers,
                plans,
                status,
                billingEndDate,
            }) => {
                // Log detallado de cada negocio durante el mapeo
                const userId =
                    customers?.id ||
                    customers?.users?.id ||
                    customers?.user_id ||
                    "Sin usuario";

                return {
                    id,
                    businessName,
                    userId: userId,
                    createdAt: formatDate(createdAt, "dd/mm/yyyy"),
                    owner: customers?.fullName || "Sin dueño",
                    membership: plans?.deviceCount || "Sin plan",
                    billingEndDate: billingEndDate
                        ? formatDate(billingEndDate, "dd/mm/yyyy")
                        : "N/A",
                    status,
                };
            }
        );

        return {
            success: true,
            message: "Negocios obtenidos exitosamente",
            data: { meta, data: formattedBusinesses },
        };
    } catch (error) {
        console.error("Error in getBusiness service:", error);
        return {
            success: false,
            message:
                error.response?.data?.message ||
                "Error en la conexión con el servidor",
        };
    }
};

export const updateBussiness = async (id, business) => {
    try {
        // Si es FormData, configurar headers apropiadamente
        const config =
            business instanceof FormData
                ? { headers: { "Content-Type": "multipart/form-data" } }
                : {};

        const response = await http.patch(
            `v1/businesses/${id}`,
            business,
            config
        );

        if (response.requestCode === 200) {
            return {
                success: true,
                message: "Negocio actualizado exitosamente",
            };
        }

        if (response.requestCode === 400) {
            return {
                success: false,
                message:
                    response.message || "Error en los datos proporcionados",
            };
        }

        if (response.requestCode === 404) {
            return {
                success: false,
                message: "Negocio no encontrado",
            };
        }

        return {
            success: false,
            message:
                response.message ||
                "Error desconocido al actualizar el negocio",
        };
    } catch (error) {
        console.error("Error in updateBussiness service:", error);
        return {
            success: false,
            message: "Error en la conexión con el servidor",
        };
    }
};

export const getPlan = async () => {
    try {
        const response = await http.get("v1/plans/select-options");

        if (!response.success) {
            return {
                success: false,
                requestCode: response.requestCode,
                message: "Error al obtener los planes",
            };
        }

        return { success: true, data: response.data };
    } catch (error) {
        console.error("Error in getPlan service:", error);
        return {
            success: false,
            message: "Error en la conexión con el servidor",
        };
    }
};

export const getTypeBusiness = async () => {
    try {
        const response = await http.get("v1/type-businesses/select-options");
        return response.data;
    } catch (error) {
        console.error("Error in getTypeBusiness service:");
        return {
            success: false,
            message: "Error en la conexión con el servidor",
        };
    }
};

export const registerBranch = async (branch) => {
    try {
        // return 0

        const response = await http.post("v1/branches/", branch);

        if (response.requestCode === 201) {
            return {
                success: true,
                message: "Sucursal registrada exitosamente",
                data: response.data, // Añadido para devolver los datos de la respuesta
            };
        }

        // Manejo de otros códigos de estado no esperados
        return {
            success: false,
            message:
                response.message ||
                response.error ||
                "La solicitud no fue exitosa",
            statusCode: response.requestCode,
        };
    } catch (error) {
        console.error("Error in registerBranch service:", error);

        // Manejo más detallado de errores
        let errorMessage = "Error en la conexión con el servidor";

        if (error.response) {
            // El servidor respondió con un código de estado fuera del rango 2xx
            errorMessage =
                error.response.data.message ||
                `Error del servidor: ${error.response.status}`;
        } else if (error.request) {
            // La solicitud fue hecha pero no se recibió respuesta
            errorMessage = "No se recibió respuesta del servidor";
        }

        return {
            success: false,
            message: errorMessage,
            error: error, // Opcional: incluir el error completo para debugging
        };
    }
};

export const getBranches = async (id) => {
    try {
        const url = `v1/businesses/${id}/branches/all`;
        const response = await http.get(url);

        if (response.requestCode === 200) {
            return {
                success: true,
                message: "Sucursales obtenidas exitosamente",
                data: response.data,
            };
        } else {
            return {
                success: false,
                message: response.message || "Error al obtener las sucursales",
                data: [],
            };
        }
    } catch (error) {
        console.error("Error in getBranches service:", error);
        return {
            success: false,
            message: "Error en la conexión con el servidor",
        };
    }
};
